import { kindMeta, directionMeta } from "./awardKinds"

// How the scan sits in the opening — decided by the kind, not by the frame,
// since it depends on the subject rather than the shape. Medals and cups are
// shot tight, so they crop to fill; diplomas and certificates must stay readable
// end to end, so they letterbox onto the mat, which is what real framing looks
// like anyway and keeps an off-orientation scan intact.
const KIND_FIT = {
  medal: "cover",
  cup: "cover",
  diploma: "contain",
  certificate: "contain",
}

// A single award as a framed picture on the wall: nail + wire above, dark wood
// moulding around a paper mat, and an engraved brass plate underneath. Every
// kind hangs in the same frame; only the chosen orientation changes its shape.
// Clicking opens the modal.
const AwardCard = ({ award, onOpen }) => {
  const open = (event) => {
    event.preventDefault()
    onOpen()
  }

  const meta = kindMeta(award.kind)
  const direction = directionMeta(award.direction)
  // Awards saved before the orientation choice existed have none; hang those
  // the same way as the default chip does.
  const shape = award.orientation === "landscape" ? "landscape" : "portrait"
  const fit = KIND_FIT[award.kind] || "contain"

  return (
    <article className={`frame frame--${shape}`}>
      <span className="frame__hanger" aria-hidden="true"></span>

      <a className="frame__link" href={`/awards/${award.id}`} onClick={open} aria-label={award.direction_label}>
        <span className="frame__body">
          <span className="frame__mat">
            <span className={`frame__opening frame__opening--${fit}`}>
              {award.photo_url ? (
                <img className="frame__art" src={award.photo_url} alt={award.direction_label} loading="lazy" decoding="async" />
              ) : (
                <span className={`frame__art frame__art--blank award-blank award-blank--${award.kind}`}>
                  <i className={`fa-solid ${meta.icon} award-blank__icon`} aria-hidden="true"></i>
                </span>
              )}
            </span>
          </span>

        </span>
      </a>

      <div className="frame__caption">
        <a className="frame__plate" href={`/awards/${award.id}`} onClick={open}>
          <i className={`fa-solid ${direction.icon}`} aria-hidden="true"></i>
          {award.direction_label}
          {award.place && (
            <span className={`frame__place frame__place--${award.place}`} title={`${award.place} місце`} aria-label={`${award.place} місце`}>
              {award.place}
            </span>
          )}
        </a>
        <span className="frame__kind">
          <i className={`fa-solid ${meta.icon}`} aria-hidden="true"></i> {meta.one}
        </span>
      </div>
    </article>
  )
}

export default AwardCard
